/**
* Maintained by Qinlili
*/
<template>
  <div class="two-steps-import">
    <!--导入的dialog-->
    <SyPopup
      :title="dialogTitle"
      :width="dialogWidth"
      size="small"
      v-model="dialogVisible">
      <div class="import-tips">
        <slot name="tip"></slot>
      </div>
      <div class="syue-clr two-steps-import-content">
        <div class="step1">
          <div class="step">
            <span class="title">{{pageText.step1}}</span>
            <span>{{pageText.downloadFile}}</span>
          </div>
          <div class="template-content">
            <span @click="downloadTemplate()" :data-spm-d="buriedPoint.downloadTemplate"></span>
          </div>
        </div>
        <div class="step2">
          <div class="step">
            <span class="title">{{pageText.step2}}</span>
            <span>{{pageText.importFile}}</span>
          </div>
          <fe-upload
            v-if="dialogVisible"
            ref="upload"
            :action="uploadPath"
            @uploadSuccess="uploadSuccess"
            :autoUpload="autoUpload"
            :data="uploadParams"
            :tips="false"
            :isChunk="isChunk"
            :extend="extend"
            :business="business"
            >
            <template v-if='$scopedSlots && $scopedSlots.tipSlot' slot='tipSlot' slot-scope="{tip}">
              <slot name="tipSlot" :tip='tip'></slot>
            </template>
          </fe-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <Buttons type="primary" @click="submit" :data-spm-d="buriedPoint.submit">{{pageText.toHandIn}}</Buttons>
      </span>
    </SyPopup>
  </div>
</template>

<script>
  import download from '../../../utils/download'
  import GetData from '../../../utils/response'
  import FeUpload from '../upload/upload.vue'
  import {popoverStatus} from '../header-process-popover/popover-status'
  import { Buttons, SyPopup } from '../../../index.js'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'two-steps-import',
    props: {
      // 弹窗标题
      dialogTitle: {
        type: String,
        default: pageText.theImport
      },
      dialogWidth: {
        type: String,
        default: '400px'
      },
      uploadPath: {
        type: String
      },
      // 上传时附带额外的参数
      uploadParams: {
        type: Object,
        default: () => ({})
      },
      autoUpload: {
        type: Boolean,
        default: true
      },
      // 是否支持分片上传
      isChunk: {
        type: Boolean,
        default: false
      },
      // 分片上传的拓展参数
      extend: {
        type: [String, Object],
        default: null
      },
      // 业务请求的参数
      business: {
        type: [String, Object],
        default: null
      },
      // 是否走异步进程
      isAsyncProcess: {
        type: Boolean,
        default: true
      },
      // 下载模板配置
      downloadTemplateConfig: {
        type: Object,
        default: {
          type: 'get',
          url: '',
          params: {}
        }
      },
      // isAsyncProcess参数为false时需要传递这个参数
      // 提交按钮config
      submitImportConfig: {
        type: Object,
        default: {
          type: 'post',
          url: '',
          params: {}
        }
      },
      // 埋点
      buriedPoint: {
        type: Object,
        default: {
          downloadTemplate: null,  // 下载模板
          submit: null   // 提交
        }
      }
    },
    components: {
      Buttons, 
      SyPopup,
      FeUpload
    },
    data () {
      return {
        pageText,
        dialogVisible: false
      }
    },
    methods: {
      // 导出批量添加商品信息获取模板
      downloadTemplate () {
        if (this.downloadTemplateConfig.type && this.downloadTemplateConfig.url) {
          download(this.downloadTemplateConfig.type, this.downloadTemplateConfig.url, this.downloadTemplateConfig.params)
        } else {
          this.$message.error(this.pageText.incorrectDownloadTemplateParameters)
        }
      },
      // 导入物料
      showImportDialog () {
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.upload.deleteFile()
        })
      },
      hideImportDialog () {
        this.dialogVisible = false
      },
      // 提交
      async submit () {
        if (this.$refs.upload.file.name === '') {
          return this.$message({
            type: 'error',
            message: this.pageText.pleaseUploadTheImportFileFirst
          })
        }
        if (!this.autoUpload) {
          this.$nextTick(() => {
            this.$refs.upload.submitUpload()
          })
        } else {
          let res = await GetData(this.$http(this.submitImportConfig.type, this.submitImportConfig.url, this.submitImportConfig.params, {
            // 'apaas-tenant-type': this.submitImportConfig.tenantType,
            'apaas-template-api-name': this.submitImportConfig.importTemplateApiName,
            ...this.submitImportConfig.headers
          }))
          if (res.isOk) {
            this.hideImportDialog()
            if (this.isAsyncProcess) {
              this.hideImportDialog()
              // 弹出气泡
              popoverStatus.show()
            } else {
              this.$emit('submit-success')
            }
          }
        }
      },
      // 上传成功
      uploadSuccess (res) {
        if (res.success && res.code === 'success') {
          if (this.isAsyncProcess && !this.autoUpload) {
            this.hideImportDialog()
            // 弹出气泡
            popoverStatus.show()
          } else {
            this.$emit('upload-success', res)
          }
        } else {
          this.$message.error(this.pageText.importFailedPleaseTryAgainLater)
        }
      }
    },
    created () {
      console.log(this.$scopedSlots, '===scopedSlots==')
    }
  }
</script>

<style scoped lang="scss">
    .two-steps-import-content{
      padding-left: 24px;
    }
    .step{
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
      .title{
        font-weight: 700;
      }
    }
    .step1 .template-content{
      margin-bottom: 30px;
      margin-left: 60px;
      span{
        display: inline-block;
        width: 100px;
        height: 100px;
        background: url("//img.sunyur.com/155254831478248718.png") no-repeat;
        -webkit-background-size: 100px;
        background-size: 100px;
      }
    }
    ::v-deep .import-tips {
      margin-top: -20px;
      margin-bottom: 10px;
    }
    .step2 ::v-deep {
      .upload-content{
        margin-left: 60px;
        padding-top: 0;
        text-align: left;
        .download-template{
          display: none;
        }
        .upload-content-info{
          text-align: left;
          .upload,
          .upload-success-icon{
            width: 100px;
            height: 100px;
            background-size: 100px;
            margin: 0 0 8px;
          }
        }
      }
    }
    ::v-deep .dialog-wrap{
      max-height: 400px !important;
      overflow: visible;
    }
</style>
